<template>
	<div
		:class="[
			'grid grid-cols-1',
			{ 'lg:grid-cols-2': !singleColumn },
		]"
	>
		<section
			:class="[
				'm-auto w-full',
				imageMaxWidth
			]"
		>
			<AnimatedTransmitImage :image="image" />
		</section>
		<section
			:class="[
				'px-4 pt-8 pb-8 m-auto lg:pl-12',
				textMaxWidth
			]"
		>
			<h2 class="text-4xl font-bold tracking-tight text-gray-900">
				{{ title }}
			</h2>
			<dl class="mt-10 space-y-2">
				<ChecklistHelper
					v-for="feature in features"
					:key="$rt(feature.id)"
					:title="$rt(feature.title)"
					:content="$rt(feature.content)"
					:use-html="useHtml"
				/>
			</dl>
			<slot />
			<dl
				v-if="hasSecondFeaturesSet"
				class="space-y-2"
			>
				<ChecklistHelper
					v-for="feature in features2"
					:key="$rt(feature.id)"
					:title="$rt(feature.title)"
					:content="$rt(feature.content)"
					:use-html="useHtml"
				/>
			</dl>
		</section>
	</div>
</template>

<script setup lang="ts">
import { toRefs, computed } from 'vue'
import type { ChecklistProps } from '@/components/checklist/types'
import type { Image } from '@/types/image'

const props = defineProps({
	image: {
		type: Object as PropType<Image>,
		required: true
	},
	features: {
		type: [ Array, Object ] as PropType<ChecklistProps[]>,
		required: true
	},
	features2: {
		type: [ Array, Object ] as PropType<ChecklistProps[]>,
		default: () => [] || {}
	},
	title: {
		type: String,
		required: true
	},
	useHtml: {
		type: Boolean,
		default: false
	},
	singleColumn: {
		type: Boolean,
		default: false
	},
	textMaxWidth: {
		type: String,
		default: 'max-w-xl'
	},
	imageMaxWidth: {
		type: String,
		default: 'max-w-xl'
	}
})

const { image, features, title, features2 } = toRefs(props)
const hasSecondFeaturesSet = computed(() => {
	// this accounts for i18n returning an object instead of an array
	return features2.value?.length || Object.keys(features2.value)?.length
})

</script>
